import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import { Link, Navigate } from "react-router-dom";

/* 🔹 Helper to strip HTML tags */
function stripHtmlTags(html = "") {
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export default class AboutUs extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    noticolor: "success",
    redirect: false,

    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },

    per_page: 20,
    page_no: 1,
  };

  componentDidMount() {
    this.getAboutUs(this.state.page_no, this.state.per_page);
  }

  getAboutUs = (page, limit) => {
    if (init() !== "success") {
      this.setState({ redirect: true });
      return;
    }

    axios
      .get(`${Constants.getUrls.getAboutUs}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            allJobs: resp.data.data.docs,
            pagination: resp.data.data,
            page_no: resp.data.data.page,
          });
        } else {
          this.showSnackbar("error", resp.data.message);
        }
      })
      .catch(() => {
        this.showSnackbar("error", "Error fetching About Us");
      });
  };

  handlePageChange = (newPage) => {
    this.getAboutUs(newPage, this.state.per_page);
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAboutUs(1, newLimit);
    });
  };

  handleDelete = (id) => {
    if (init() !== "success") return;

    axios
      .delete(Constants.deleteUrls.deleteSubject + id)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.showSnackbar("success", resp.data.message);
          this.getAboutUs(this.state.page_no, this.state.per_page);
        }
      })
      .catch(() => {
        this.showSnackbar("error", "Delete failed");
      });
  };

  showSnackbar = (color, message) => {
    this.setState({
      notification: true,
      noticolor: color,
      message,
    });

    setTimeout(() => {
      this.setState({ notification: false, message: "" });
    }, 2500);
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                About Us
              </MDTypography>
            </MDBox>

            {/* CREATE BUTTON */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addsubject">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>

            {/* TABLE */}
            <MDBox>
              <DataTable
                table={{
                  columns: [
                    { Header: "Serial", accessor: "serial", width: "6%" },
                    { Header: "Title", accessor: "title" },
                    { Header: "Description", accessor: "description" },
                    { Header: "Action", accessor: "action" },
                  ],
                  rows: this.state.allJobs.map((job, index) => {
                    const cleanText = stripHtmlTags(job.description || "");
                    const preview =
                      cleanText.length > 200
                        ? cleanText.substring(0, 200) + "..."
                        : cleanText;

                    return {
                      serial: index + 1,
                      title: job.title || "-",
                      description: (
                        <MDTypography variant="caption" color="text">
                          {preview}
                        </MDTypography>
                      ),
                      action: (
                        <>
                          <div>
                            <Link
                              to={{
                                pathname: "/updatesubject/" + job._id,
                                state: { data: job },
                              }}
                            >
                              <MDButton
                                variant="outlined"
                                size="small"
                                color="success"
                              >
                                Update
                              </MDButton>
                            </Link>
                          </div>

                          <div style={{ marginTop: "0.75rem" }}>
                            <MDButton
                              variant="outlined"
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(job._id)}
                            >
                              Delete
                            </MDButton>
                          </div>
                        </>
                      ),
                    };
                  }),
                }}
                entriesPerPage={{ defaultValue: 20 }}
                page_no={this.state.pagination.page}
                totalPages={this.state.pagination.totalPages}
                hasNextPage={this.state.pagination.hasNextPage}
                hasPrevPage={this.state.pagination.hasPrevPage}
                isnextPage={this.state.pagination.nextPage}
                prevPage={this.state.pagination.prevPage}
                totalDocs={this.state.pagination.totalDocs}
                onPageChange={this.handlePageChange}
                onEntriesPerPageChange={this.handleEntriesPerPageChange}
              />
            </MDBox>

            {/* SNACKBAR */}
            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="Fabinov8 | About Us"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
